export default {"src":"/_next/static/media/google-play-badge.6abedf3b.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};